module.exports = __webpack_public_path__ + "fonts/iconfont.32636a3b.woff";